module.exports = "<div>\n<div  class=\"allTagPlaceHolder\">\n\t\n</div>\n<div  class=\"tagPlaceholder\">\n\t\n</div>\n</div>"